module.exports = __webpack_public_path__ + "img/010-champion.4e211f8b.png";